export default __webpack_public_path__ + "static/media/breakfast_4.c919caf7.jpg";